var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 0.292893C0.683417 -0.097631 1.31658 -0.0976311 1.70711 0.292893L8.67028 7.25606C8.85782 7.4436 8.96317 7.69795 8.96317 7.96317C8.96317 8.22839 8.85782 8.48274 8.67028 8.67028L1.70711 15.6334C1.31658 16.024 0.683417 16.024 0.292893 15.6334C-0.0976311 15.2429 -0.097631 14.6098 0.292893 14.2192L6.54896 7.96317L0.292893 1.70711C-0.097631 1.31658 -0.0976311 0.683418 0.292893 0.292893Z",
    fill: "#576473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.f27523c1540d463f80e5f7f97a2b9e08.svg";
export { ForwardRef as ReactComponent };